var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.572 8.332c.868 0 1.572-.704 1.572-1.572 0-.869-.704-1.572-1.572-1.572C3.704 5.188 3 5.89 3 6.76c0 .868.704 1.572 1.572 1.572zm14.804-.655c.217 0 .393-.176.393-.393V6.236c0-.217-.176-.393-.393-.393H7.586c-.218 0-.394.176-.394.393v1.048c0 .217.176.393.393.393h11.791zM4.572 13.572c.868 0 1.572-.704 1.572-1.572 0-.868-.704-1.572-1.572-1.572C3.704 10.428 3 11.132 3 12c0 .868.704 1.572 1.572 1.572zm14.804-.655c.217 0 .393-.176.393-.393v-1.048c0-.217-.176-.393-.393-.393H7.586c-.218 0-.394.176-.394.393v1.048c0 .217.176.393.393.393h11.791zM4.572 18.812c.868 0 1.572-.703 1.572-1.572 0-.868-.704-1.572-1.572-1.572-.868 0-1.572.704-1.572 1.572 0 .869.704 1.572 1.572 1.572zm14.804-.655c.217 0 .393-.176.393-.393v-1.048c0-.217-.176-.393-.393-.393H7.586c-.218 0-.394.176-.394.393v1.048c0 .217.176.393.393.393h11.791z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconList);
export default __webpack_public_path__ + "static/media/elements-icon-list.828c0eaa649976e0a981fd1e9e8d419a.svg";
export { ForwardRef as ReactComponent };